import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CAIS_REPORT_BASE_PATH } from '../../../../../../../../../features/trade-reporting/cais/cais-report-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cais/_cais')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'cais-report-list',
        label: 'Reports',
        to: CAIS_REPORT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
